<div mat-dialog-title class="header-row">
  <h2>Add Brands</h2>
  <button mat-flat-button (click)="onAddBrand()"><mat-icon>add</mat-icon>Add Another</button>
</div>
<div mat-dialog-content>
  <ng-container *ngFor="let newBrand of newBrandForms.controls">
    <div class="brand-wrapper" gdColumns.lt-sm="1fr">
        <mat-form-field>
          <mat-label>Brand Name</mat-label>
          <input matInput [formControl]="newBrand.controls.name">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Brand Logo Url</mat-label>
          <input matInput [formControl]="newBrand.controls.brandLogoUrl">
          <mat-checkbox matSuffix [matTooltip]="'Only show brand logo in callouts'"
            [formControl]="newBrand.controls.showBrandLogoOnly"></mat-checkbox>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Supplier</mat-label>
          <input matInput [formControl]="newBrand.companyName" type="text" [matAutocomplete]="supplierAuto">
          <mat-autocomplete #supplierAuto="matAutocomplete" (optionSelected)="onSupplierSelected($event, newBrand)" (opened)="clearCompanyField(newBrand)">
            <mat-option *ngFor="let supplier of newBrand.filteredSuppliers | async" [value]="supplier.name">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                  <span [innerHtml]="supplier.name | highlight: newBrand.companyName.value"></span>
                </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <div class="quality-selector" fxLayout.lt-md="column">
          <mat-label>Quality Level</mat-label>
          <mat-button-toggle-group [formControl]="newBrand.controls.qualityLevel" fxLayout.lt-sm="column">
            <mat-button-toggle [value]="null">None</mat-button-toggle>
            <ng-container *ngFor="let quality of QualityLevel | enumKeyValue">
              <mat-button-toggle [value]="quality.value">{{quality.key}}</mat-button-toggle>
            </ng-container>
          </mat-button-toggle-group>
        </div>
    </div>
  </ng-container>
</div>
<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false"><mat-icon>close</mat-icon>Cancel</button>
  <button mat-flat-button (click)="onSaveBrands()"><mat-icon>save</mat-icon>Save</button>
</div>